<template lang="">
  <q-btn
    color="red"
    icon="delete"
    label="Sil"
    no-caps
    @click="confirm = true"
  />
  <q-dialog v-model="confirm">
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="delete" color="red" text-color="white" />
        <span class="q-ml-sm"
          >Abonelik paketi silinecektir. Onayliyor musunuz?</span
        >
      </q-card-section>
      <q-card-actions align="right">
        <q-btn v-close-popup flat label="Vazgec" color="secondary" />
        <q-btn
          v-close-popup
          flat
          label="Onayla"
          color="red"
          @click="deleteSubscription"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
import { ref, inject } from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'
export default {
  props: {
    subscriptionId: String,
  },
  setup(props) {
    const $q = useQuasar()
    const emitter = inject('emitter')

    const deleteSubscription = () => {
      axios
        .delete('/subscriptions/' + props.subscriptionId)
        .then(() => {
          $q.notify(notify.success('Abonelik paketi basariyla silindi.'))
          emitter.emit(eventNames.REFRESH_SUBSCRIPTIONS)
        })
        .catch(() => {
          $q.notify(notify.warning('Abonelik paketi silinemedi.'))
        })
    }

    return {
      confirm: ref(false),
      deleteSubscription,
    }
  },
}
</script>
